module.exports = __webpack_public_path__ + "dbcd73e4bbd872537e23715f8843c007.png";